var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7994_107279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8896 10.0002L8.63569 16.5392C8.27925 16.914 8.29022 17.5072 8.66499 17.865C9.03976 18.2228 9.63257 18.2095 9.98804 17.8361L16.863 10.6486C17.2097 10.2848 17.2097 9.71579 16.863 9.35212L9.98804 2.16462C9.63038 1.79106 9.03726 1.77762 8.66226 2.13532C8.47241 2.32047 8.37476 2.56657 8.37476 2.81266C8.37476 3.04583 8.46144 3.27907 8.63476 3.46071L14.8896 10.0002ZM1.13648 3.4611L7.39038 10.0002L1.13648 16.5392C0.780029 16.914 0.791006 17.5072 1.16577 17.865C1.54054 18.2228 2.13374 18.2093 2.49155 17.8357L9.36655 10.6482C9.71323 10.2844 9.71323 9.7154 9.36655 9.35172L2.49156 2.16422C2.1339 1.79067 1.54077 1.77723 1.16577 2.13493C0.972415 2.32047 0.874757 2.56657 0.874757 2.81266C0.874757 3.04704 0.960695 3.2775 1.13648 3.4611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7994_107279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white",
    transform: "translate(17.75 20) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsRight);
export default __webpack_public_path__ + "static/media/chevrons-right.99f0d2b661b0e7d0cadf0e56cf090c10.svg";
export { ForwardRef as ReactComponent };